<template>
  <div>
    <div class="d-flex align-center mb-6">
      <v-btn icon @click="$emit('changeComponent', 'UsersTable')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h2 class="primary--text ml-2">{{ isEdit ? 'Editar usuario' : 'Nuevo usuario' }}</h2>
    </div>

    <v-card class="pa-8 rounded-lg">
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.username"
              label="Nombre de usuario"
              :rules="requiredText"
              outlined
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6" v-if="!isEdit">
            <v-text-field
              v-model="form.password"
              label="Contraseña"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              :rules="passwordRules"
              outlined
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-select
              v-model="form.rol"
              :items="roles"
              label="Rol"
              :rules="requiredText"
              outlined
            ></v-select>
          </v-col>

          <v-col cols="12" md="6" v-if="isEdit">
            <v-select
              v-model="form.estatus"
              :items="estatusItems"
              item-text="text"
              item-value="value"
              label="Estatus"
              outlined
            ></v-select>
          </v-col>
        </v-row>

        <div class="d-flex justify-end mt-4">
          <v-btn class="mr-3" color="error" depressed @click="$emit('changeComponent', 'UsersTable')">
            CANCELAR
          </v-btn>
          <v-btn color="primary" depressed :disabled="!valid" :loading="saving" @click="submit">
            {{ isEdit ? 'ACTUALIZAR' : 'CREAR USUARIO' }}
          </v-btn>
        </div>
      </v-form>
    </v-card>

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000" top>
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import Users from "../../domain/Users";

export default {
  name: "UserNew",
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: false,
      saving: false,
      showPassword: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      form: {
        username: "",
        password: "",
        rol: "user",
        estatus: true,
      },
      roles: ["admin", "user"],
      estatusItems: [
        { text: "Activo", value: true },
        { text: "Inactivo", value: false },
      ],
      requiredText: [(v) => !!v || "Campo requerido"],
      passwordRules: [
        (v) => !!v || "La contraseña es requerida",
        (v) => (v && v.length >= 6) || "Mínimo 6 caracteres",
      ],
    };
  },
  mounted() {
    if (this.isEdit && this.item) {
      this.form = {
        _id: this.item._id,
        username: this.item.username,
        rol: this.item.rol,
        estatus: this.item.estatus,
      };
    }
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;
      try {
        if (this.isEdit) {
          await Users.update(this.form);
          this.showSnackbar("Usuario actualizado correctamente", "success");
        } else {
          await Users.create({
            username: this.form.username,
            password: this.form.password,
            rol: this.form.rol,
          });
          this.showSnackbar("Usuario creado correctamente", "success");
        }
        this.saving = false;
        setTimeout(() => {
          this.$emit("changeComponent", "UsersTable");
        }, 1000);
      } catch (error) {
        this.saving = false;
        const msg = error.response?.data?.message || "Error al guardar usuario";
        this.showSnackbar(msg, "error");
        console.warn(error);
      }
    },
    showSnackbar(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
};
</script>
